<template>
    <div class="wrapper">
        <v-layout>
            <v-main style="font-size:14px;">
                <v-container>
                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                                        <h4 class="
                                        text-h6
                                        text-md-h6
                                        text-lg-h5
                                        text-xl-h5
                                        text-truncate">
                                            Imprint
                                        </h4>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <b>Provider Information</b><br />
                            Department of Medical Bioinformatics, University Medical Center Göttingen<br />
                            Goldschmidtstraße 1<br />
                            37077 Göttingen<br />
                            Germany<br /><br />
                            Website: <a href="https://bioinformatics.umg.eu">https://bioinformatics.umg.eu</a> <br /><br/>

                            <!--<b>Legal Information</b><br/>
                            Registered in: [City of Registration, if applicable]
                            Commercial Register: [Registration Number, if applicable]
                            VAT ID: [VAT Identification Number, if applicable]
                            Tax Number: [Tax Number, if applicable]-->

                            <b>Responsible for Content (as per § 18 Abs. 2 MStV)</b><br />
                            Prof. Tim Beißbarth<br />
                            Goldschmidtstraße 1<br/>
                            37077 Göttingen <br />
                            Germany<br/><br />
                            Phone: +49 551 3961782<br />
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-layout>
    </div>
</template>
<style>
</style>
